import { render, staticRenderFns } from "./BlockVideo.vue?vue&type=template&id=5ddd3aa2&scoped=true"
import script from "./BlockVideo.vue?vue&type=script&lang=js"
export * from "./BlockVideo.vue?vue&type=script&lang=js"
import style0 from "./BlockVideo.vue?vue&type=style&index=0&id=5ddd3aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddd3aa2",
  null
  
)

export default component.exports